"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationNextStepDefinition = void 0;
const WidgetFormStepPluginDefinition_1 = require("../../../../Plugin/WidgetStep/WidgetFormStepPluginDefinition");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const StepEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/StepEvents");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const QuestionnaireFormStepBase_1 = require("./QuestionnaireFormStepBase");
const InchcapeSelectorEvents_1 = require("../../Enum/InchcapeSelectorEvents");
const QuestionnaireTypes_1 = require("../../../../Enum/QuestionnaireTypes");
const ValuationNextStepsForm_1 = require("../FormHandler/ValuationNextStepsForm");
const Dealer_1 = require("../../../../Model/Dealer");
const QuestionAnswerOptionType_1 = require("../../../../Enum/QuestionAnswerOptionType");
const InchcapeInternalEvents_1 = require("../../../../Enum/InchcapeInternalEvents");
class ValuationNextStep extends QuestionnaireFormStepBase_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider, repoFactory, answeredQuestionnaireExtractor) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider);
        this.questionnaireId = QuestionnaireTypes_1.QuestionnaireTypes.NEXT_ACTIONS;
        this.questionnaireRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.QUESTIONNAIRE, { config: widgetConfig });
        this.answeredQuestionnaireRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.ANSWERED_QUESTIONNAIRE, { config: widgetConfig });
        this.valuationRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.VALUATION, { config: widgetConfig });
        this.dealerRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.DEALER, { config: widgetConfig });
        this.contactMethodRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.CONTACT_METHOD, { config: widgetConfig });
        this.customerRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.CUSTOMER, { config: widgetConfig });
        this.answeredQuestionnaireExtractor = answeredQuestionnaireExtractor;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("plugin.provider.form_handler"), container.get("factory.repository"), container.get("valuation.answer_extractor"));
    }
    /**
     * @inheritDoc
     */
    getQuestionnaire() {
        return [this.questionnaire];
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.VALUATION_NEXT).getTemplate();
    }
    /**
     * @inheritDoc
     */
    initialize() {
        this.state.setErrorMessage(false);
        this.state.setNextStepAnswersEnum(QuestionAnswerOptionType_1.QuestionNextStepsAnswers);
        return Promise.all([
            this.loadQuestionnaire(),
            this.loadDealers(),
            this.loadContactMethods(),
        ]);
    }
    /**
     * Loads the types of contact methods.
     */
    loadContactMethods() {
        return this.contactMethodRepo.getAll()
            .then((contactMethods) => {
            this.state.setContactMethods(contactMethods.getArray());
        });
    }
    /**
     * Load the next steps questionnaire.
     */
    loadQuestionnaire() {
        return this.questionnaireRepo.get(this.questionnaireId)
            .then((questionnaire) => {
            const valuation = this.state.getValuation();
            this.questionnaire = questionnaire[0];
            // Sell is the default choice.
            this.state.setUserNextStepChoice(QuestionAnswerOptionType_1.QuestionNextStepsAnswers.SELL);
            // Based on the context we should display only one option on step5 questionnaire,
            // option which has to be selected by default.
            if (this.widgetConfig.getDisableNextStepSellOption()) {
                this.displaySecondAnswerOnly();
            }
            // For Australia, display only the first questionnaire answer
            if (this.state.isAustraliaDistribution()) {
                this.displayFirstAnswerOnly();
            }
            if (valuation.getAnsweredQuestionnaires().count()) {
                const answers = valuation.getAnsweredQuestionnaires().find((answeredQuestionnaire) => answeredQuestionnaire.getId() === this.questionnaireId);
                const existingAnswer = this.answeredQuestionnaireExtractor.getAnswerToQuestion(valuation, 'next_steps', QuestionnaireTypes_1.QuestionnaireTypes.NEXT_ACTIONS);
                if (!this.widgetConfig.getDisableNextStepSellOption()) {
                    this.state.setFinalQuestionnaireAnswers(answers);
                    if (existingAnswer) {
                        this.state.setUserNextStepChoice(existingAnswer);
                    }
                }
            }
            this.state.setQuestionnairesFinal(this.questionnaire);
        });
    }
    displayFirstAnswerOnly() {
        this.state.setUserNextStepChoice(QuestionAnswerOptionType_1.QuestionNextStepsAnswers.SELL);
        this.questionnaire.getQuestions().getArray().forEach((question) => {
            question.setDefaultAnswer([question.getPossibleAnswers().getArray()[0].getValue()]);
            question.getPossibleAnswers().getArray().splice(1, 1);
        });
    }
    displaySecondAnswerOnly() {
        this.state.setUserNextStepChoice(QuestionAnswerOptionType_1.QuestionNextStepsAnswers.TRADE_IN);
        this.questionnaire.getQuestions().getArray().forEach((question) => {
            question.setDefaultAnswer([question.getLastAnswer()]);
            question.getPossibleAnswers().getArray().shift();
        });
    }
    /**
     * Loads dealers in state.
     */
    loadDealers() {
        if (this.state.getDealers()) {
            return Promise.resolve();
        }
        return this.dealerRepo.getAll()
            .then((dealers) => {
            const dealersPerSearchKey = {};
            dealers.getArray().forEach((dealer) => {
                dealersPerSearchKey[dealer.getSearchKey()] = dealersPerSearchKey[dealer.getSearchKey()] || [];
                dealersPerSearchKey[dealer.getSearchKey()].push(dealer);
            });
            if (Object.keys(dealersPerSearchKey).length > 1) {
                this.state.setDealers(dealersPerSearchKey);
            }
            else {
                this.state.setDealers(dealers.getArray());
            }
        });
    }
    /**
     * @inheritDoc
     */
    registerHandlers() {
        super.registerHandlers();
        const container = document.getElementById(this.widgetConfig.getContainerId());
        const questionAnswers = container.querySelectorAll('[data-px-question-answer]');
        for (let i = 0, question; question = questionAnswers[i++];) {
            question.addEventListener('click', (e) => {
                this.state.setUserNextStepChoice(e.target.value);
                this.form.initialize([this.questionnaire]);
            });
        }
    }
    /**
     * Determine if exception is triggered on valuation.
     *
     * @param valuation
     */
    isValuationException(valuation) {
        return !!valuation.getContext();
    }
    /**
     * Sets the exception step.
     */
    triggerExceptionFlow() {
        const valuation = this.state.getValuation();
        this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.BLOCKED_VALUATION, valuation.getToken());
        this.eventContext.emit(InchcapeInternalEvents_1.InchcapeInternalEvents.SET_STEP, StepTypes_1.StepTypes.EXCEPTION);
        return Promise.resolve();
    }
    /**
     * @inheritDoc
     */
    submit(answersData) {
        const valuation = this.state.getValuation();
        const customer = valuation.getCustomer();
        const oldCustomer = customer.clone();
        valuation.setPreferredDealer(new Dealer_1.default().setId(answersData.extra.preferred_dealer || null));
        valuation.setCompleted(true);
        customer.setSubscriptions(answersData.extra.preferred_contact_method ?
            [answersData.extra.preferred_contact_method] : []);
        customer.setComment(answersData.extra.comment || null);
        // @TODO: Add back parallel calls when salesforce support proper updating.
        // It is removed for now since we are not triggering OE valuation update on
        // questionnaire entities.
        return Promise.all([
            this.answeredQuestionnaireRepo.create(valuation, this.questionnaireId, answersData.questionnaire),
            customer.getId() ?
                this.customerRepo.update(customer, oldCustomer) :
                this.customerRepo.create(customer)
        ])
            .then(([, updatedCustomer]) => {
            this.state.setCustomer(updatedCustomer);
            return this.valuationRepo.update(valuation, true);
        })
            .then((updatedValuation) => {
            this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.UPDATE_VALUATION, updatedValuation);
            this.state.setValuation(updatedValuation);
            if (!this.isValuationException(updatedValuation)) {
                this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.COMPLETED_VALUATION, valuation.getToken());
                this.eventContext.emit(StepEvents_1.StepEvents.STEP_FINISHED);
            }
            else {
                return this.triggerExceptionFlow();
            }
        }).catch((error) => {
            this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
        });
    }
}
exports.default = ValuationNextStep;
exports.ValuationNextStepDefinition = new WidgetFormStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.VALUATION_NEXT,
    form_id: ValuationNextStepsForm_1.ValuationNextStepsFormDefinition.getId(),
    class: ValuationNextStep,
    priority: 1600
});
